import { useEffect, useRef } from "react";

/**
 * Real economic-events calendar via TradingView's free Events widget.
 * Shows medium + high importance releases for gold/USD-relevant economies.
 * Live data, no API key.
 */
export function EconomicCalendar({ theme = "dark", height = 550 }) {
  const ref = useRef(null);

  useEffect(() => {
    const container = ref.current;
    if (!container) return;
    container.innerHTML = "";
    const widget = document.createElement("div");
    widget.className = "tradingview-widget-container__widget";
    widget.style.height = "100%";
    widget.style.width = "100%";
    container.appendChild(widget);

    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-events.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = JSON.stringify({
      colorTheme: theme === "light" ? "light" : "dark",
      isTransparent: true,
      width: "100%",
      height,
      locale: "en",
      importanceFilter: "0,1",
      countryFilter: "us,eu,gb,jp,cn,ca,au,ch",
    });
    container.appendChild(script);

    return () => { try { container.innerHTML = ""; } catch { /* ignore */ } };
  }, [theme, height]);

  return (
    <div className="tradingview-widget-container" ref={ref}
      style={{ height, width: "100%" }} data-testid="economic-calendar" />
  );
}
